import {
  AccountInfo,
  AuthenticationResult,
  SilentRequest
} from '@azure/msal-browser';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal
} from '@azure/msal-react';
import { Button, Result } from 'antd';
import React, { useEffect, useState } from 'react';
import {
  getTokenForBrowser,
  handleLogout,
  parseUserAndValidateRoles,
  saveCookie
} from '../../utils/auth.utils';

import { IsAdminProp } from '../../types/props/isAdmin.props';
import { Layout } from '../../pages';
import { RouteConstants } from '../../constants/route.constants';
import { useNavigate } from 'react-router';

export default (Page: React.ComponentType<IsAdminProp>, isAdmin = false) => {
  const SecureComponent = (props: any) => {
    const [isUserAuthorized, setIsUserAuthorized] = useState(true);
    const [isUserAdmin, setIsUserAdmin] = useState(false);
    const navigate = useNavigate();

    const { instance } = useMsal();

    // get id token for the active account
    const acquireToken = async (): Promise<void> => {
      const account: AccountInfo | null = instance.getActiveAccount();
      if (account)
        instance
          .acquireTokenSilent((account ? { account } : {}) as SilentRequest)
          .then((tokenResponse: AuthenticationResult) => {
            saveCookie(tokenResponse.idToken);
          })
          .catch(error => {
            console.log(
              'error while fetching token secure component :: ',
              error
            );
            navigate(RouteConstants.LOGIN);
          });
      else {
        // console.log('no active account found');
        navigate(RouteConstants.LOGIN);
      }
    };
    // get user from cookie and authorize user
    const validateAccessToken = async (): Promise<void> => {
      let loggedInUser: string | undefined | false = await getTokenForBrowser();

      // if user token is not in cookie
      // acquire new token and get logged in user
      if (!loggedInUser) {
        await acquireToken();
        loggedInUser = await getTokenForBrowser();
      } else {
        const parsedUser: any = parseUserAndValidateRoles(loggedInUser);
        // TODO handle else case if needed, discuss with RB
        if (parsedUser) {
          // get user's role, and authorize
          const userRoles: string[] = parsedUser.roles;

          userRoles.includes(
            process.env.REACT_APP_AZURE_ADMIN_ROLE as string
          ) && setIsUserAdmin(true);

          // if page accessible only by admin and user is not an Admin eg: ['View']
          isAdmin &&
            !userRoles.includes(
              process.env.REACT_APP_AZURE_ADMIN_ROLE as string
            ) &&
            setIsUserAuthorized(false);
        }
      }
    };

    useEffect(() => {
      validateAccessToken();
    }, []);

    if (!isUserAuthorized) {
      return (
        <Result
          status={'warning'}
          title='Unauthorized access'
          extra={[
            <Button
              type='primary'
              key='logout'
              onClick={() => handleLogout(instance)}>
              Logout
            </Button>
          ]}
        />
      );
    }

    return (
      <>
        <AuthenticatedTemplate>
          <Layout isAdmin={isUserAdmin}>
            <Page {...props} isAdmin={isUserAdmin} />
          </Layout>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <Result
            status={'error'}
            title="You're not signed in"
            extra={[
              <Button
                key='login'
                type='primary'
                onClick={() => navigate(RouteConstants.LOGIN)}>
                Login
              </Button>
            ]}
          />
        </UnauthenticatedTemplate>
      </>
    );
  };

  return SecureComponent;
};
